import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const FullScreenIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http:www.w3.org/2000/svg"
    >
      <path
        d="M10.295 1.705L7.285 4.715"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
      />
      <path
        d="M4.715 7.285L1.705 10.295"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
      />
      <path
        d="M7.285 7.285L10.295 10.295"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
      />
      <path
        d="M1.705 1.705L4.715 4.715"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
      />
      <path
        d="M10.29 7.71H7.71V10.29"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M1.71 4.29H4.29V1.71"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M4.29 10.29V7.71H1.71"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M7.71 1.71V4.29H10.29"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  );
};
